import React, { useCallback, useEffect } from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { useValidation } from 'gw-portals-validation-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import AdacDigitalWizardPageTemplate from '../../templates/AdacDigitalWizardPageTemplate';
import metadata from './AdacIncidentTypePage.metadata.json5';
import messages from '../../FNOLAdacWizard.messages';
import styles from './AdacIncidentTypePage.module.scss';
import './AdacIncidentTypePage.messages';

const DESCRIPTION_MAX_LENGTH = 1333;

function AdacIncidentTypePage(props) {
    const {
        wizardData: claimVM,
        updateWizardData
    } = props;
    const { policyType } = _.get(claimVM, 'policy.value');
    const lobPolicyType = _.lowerFirst(policyType);
    const lobExtension = claimVM.lobs[lobPolicyType];
    if (_.isEmpty(claimVM.generalLob)) {
        _.set(claimVM, 'generalLob', lobExtension);
    }
    const {
        onValidate,
        isComponentValid,
        initialValidation,
        disregardFieldValidation,
        registerComponentValidation,
    } = useValidation('AdacIncidentTypePage');

    useEffect(() => {
        registerComponentValidation(() => {
            const lossCauseVM = _.get(claimVM, 'lossCause');
            const lossCauseDescriptionVM = _.get(claimVM, 'description');
            if (!_.isNil(lossCauseVM) && _.get(lossCauseVM.value, 'code') === 'death') {
                return lossCauseVM.aspects.valid && lossCauseVM.aspects.subtreeValid;
            }
            return lossCauseVM.aspects.valid
            && lossCauseVM.aspects.subtreeValid
            && lossCauseDescriptionVM.aspects.subtreeValid;
        });
    }, [claimVM, registerComponentValidation]);

    const onLossCauseChange = useCallback((value, path) => {
        if (value === 'death') {
            disregardFieldValidation('AdacIncidentTypePage');
        }
        _.set(claimVM, 'description', undefined);
        _.set(claimVM, path, value);
        updateWizardData(claimVM);
    }, [claimVM, disregardFieldValidation, updateWizardData]);

    const charCounter = useCallback(() => {
        const description = _.get(claimVM.value, 'description');
        if (description !== undefined && description.length > 0) {
            return (
                <p className={styles.charCounter}>{`${description.length}/${DESCRIPTION_MAX_LENGTH}`}</p>
            );
        }
        return null;
    }, [claimVM.value.description]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        illnessRadioButtonCard: {
            value: _.get(claimVM.value, 'lossCause')
        },
        accidentRadioButtonCard: {
            value: _.get(claimVM.value, 'lossCause')
        },
        deathRadioButtonCard: {
            value: _.get(claimVM.value, 'lossCause')
        },
        illnessLossDescriptionContainer: {
            visible: _.isEqual(_.get(claimVM, 'lossCause.value.code'), 'illness'),
        },
        illnessLossDescriptionField: {
            maxLength: DESCRIPTION_MAX_LENGTH
        },
        accidentLossDescriptionContainer: {
            visible: _.isEqual(_.get(claimVM, 'lossCause.value.code'), 'accident'),
        },
        accidentLossDescriptionField: {
            maxLength: DESCRIPTION_MAX_LENGTH
        }
    };

    const resolvers = {
        resolveComponentMap: {
            charCounter: charCounter
        },
        resolveCallbackMap: {
            onLossCauseChange
        }
    };
    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, claimVM, id, path, overrideProps);
        },
        [claimVM, overrideProps]
    );

    return (
        <WizardPage
            showCancel={false}
            nextLabel={messages.next}
            previousLabel={messages.previous}
            disableNext={!isComponentValid}
            skipWhen={initialValidation}
            template={AdacDigitalWizardPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                onValidationChange={onValidate}
                resolveValue={readValue}
            />
        </WizardPage>
    );
}

AdacIncidentTypePage.propTypes = wizardProps;
export default withRouter(AdacIncidentTypePage);
